lp.cart = lp.cart || {};

/**
 * @fires beforeClose.shippingSelect
 * @fires afterClose.shippingSelect
 */
lp.cart.shippingSelect = {
	init: function () {

		var $select = $(this);

		// if select has more than one option
		if ($select.children().length > 1 || ($select.is('[disabled]') && !$select.hasClass('defaultzipsetting'))) {

			// create the new select box
			var selectedValue = $(this).val(),
				disabled = $(this).is('[disabled]') ? ' disabled' : '',
				lpSelectNewPre =
					'<div class="lpSelectNew' + disabled + '" tabindex="0"><div class="dropdown"><div class="chosen">',
				lpSelectNew =
					'</div><div class="dropdownBtn"><div class="arrowDown"></div></div></div><div class="options hidden">',
				lpSelectNewOverrides = '<div class="overrides"><p>Overrides <span>(confirm availability)</span></p>',
				hasOverrides = false,
				$estimatedDelivery;
			// copy each of the options
			$select.children().each(function () {

				// declare vars
				var $this = $(this),
					thisValue = $this.attr('value'),
					// select the selected
					selected = thisValue == selectedValue ? ' selected highlighted' : '',
					// parse shipping info
					optionPartsArray = $this.text().split(': '),
					// if isOverride
					isOverride = optionPartsArray[0].indexOf('*') == 0,
					// if isOverride, remove the identifying '*'
					shippingType = isOverride ? optionPartsArray[0].substr(1) : optionPartsArray[0],
					shippingDays = optionPartsArray.length > 1 ? optionPartsArray[1].trim() : '',
					shippingCost = optionPartsArray.length > 2 ? optionPartsArray[2].trim() : '',
					shippingSale = optionPartsArray.length > 3 ? optionPartsArray[3].trim() : '',
					// set default values
					shippingDays = shippingDays,
					newOption;

				// add parsed shipping info
				newOption = '<div class="shippingType';
				newOption += shippingDays === '' ? ' noShippingDays' : '';
				newOption += '">' + shippingType + '</div>';
				newOption += '<div class="shippingDays">' + shippingDays + '</div>';
				newOption += '<div class="shippingCost';
				newOption += shippingCost === 'FREE*' || shippingCost === 'FREE' ? ' free' : '';
				newOption += shippingSale ? ' onSale' : '';
				newOption += '">' + shippingCost + '</div>';
				newOption += shippingSale ? '<div class="shippingSale">' + shippingSale + '</div>' : '';

				// add overrides and regular options
				if (isOverride) {

					lpSelectNewOverrides +=
						'<div class="optionContainer' +
						selected +
						'"><div class="option" data-value="' +
						thisValue +
						'">' +
						newOption +
						'</div></div>';

				} else {

					lpSelectNew +=
						'<div class="optionContainer"><div class="option' +
						selected +
						'" data-value="' +
						thisValue +
						'">' +
						newOption +
						'</div></div>';

				}
				// set the chosen option
				lpSelectNewPre += selected.length ? newOption : '';
				// if isOverride, then select box hasOverrides
				hasOverrides = isOverride ? true : hasOverrides;

			});
			// close up tags
			lpSelectNew += hasOverrides ? lpSelectNewOverrides + '</div></div>' : '</div>';
			// if disabled, hide with div
			lpSelectNew += disabled ? '<div class="disabled"></div></div>' : '</div>';
			// add lpSelectNew to dom
			$select.after(lpSelectNewPre + lpSelectNew);
			$estimatedDelivery = $select.siblings('.estimatedDelivery');
			if ($estimatedDelivery.length) {

				$select.next('.lpSelectNew').children('.options').append($estimatedDelivery.clone(true));

			}

			// disable if needed
			if (disabled) {

				$select.off('click.lpSelect keydown.lpSelect hover.lpSelect');

			} else if (!$('html').data('lpSelectInitialized')) {

				$('html')
					.on('click.lpSelect', lp.cart.shippingSelect.click)
					.on('keydown.lpSelect', '.lpSelectNew', lp.cart.shippingSelect.keydown)
					.data('lpSelectInitialized', true)
					.on('mouseenter.lpSelect', '.optionContainer', lp.cart.shippingSelect.hover);

				if (window.isIpad()) {

					$('html').on('touchstart.lpSelect', '.optionContainer', lp.cart.shippingSelect.click);

				}

			}

			// if we have special flag then show dropdown opened with delay specified by this flag
			var delayedOpen = $(this).data('lpselect-open');
			if (delayedOpen >= 0) {

				window.setTimeout(function () {

					var event = jQuery.Event('click.lpSelect');
					event.target = $select.next('.lpSelectNew').find('.chosen:first');
					$('html').trigger(event);

				}, delayedOpen);

			}

			// if only one option, display text

		} else {

			// declare vars
			var rightAlign = $select.hasClass('defaultzipsetting') ? 'rightAlign' : '',
				// parse shipping info
				optionPartsArray = $select.text().split(': '),
				// if isOverride, remove the identifying '*'
				shippingType = optionPartsArray[0].trim(),
				shippingDays = optionPartsArray.length > 1 ? optionPartsArray[1].trim() : '',
				shippingCost = optionPartsArray.length > 2 ? optionPartsArray[2].trim() : '',
				shippingSale = optionPartsArray.length > 3 ? optionPartsArray[3].trim() : '',
				singleOption =
					'<div class="singleOption ' +
					rightAlign +
					'"><span class="theType">' +
					shippingType +
					'</span>' +
					'<span class="thePrice';

			singleOption += shippingCost === 'FREE*' || shippingCost === 'FREE' ? ' free' : '';
			singleOption += shippingSale ? ' onSale' : '';
			singleOption += '">' + shippingCost + '</span>';
			singleOption += '<span class="theDays">' + shippingDays + '</span>';
			singleOption += shippingSale ? '<div class="theOriginal">' + shippingSale + '</div>' : '';
			singleOption += '</div>';
			// add text to dom
			$select.after(singleOption);

		}

	},
	click: function (e) {

		// declare vars
		var $target = $(e.target),
			$scope = $target.closest('.lpSelectNew'),
			$optionContainer = $target.is('.optionContainer') ? $target : $target.closest('.optionContainer');

		if ($target.closest('.lpSelectNew').length) {

			e.preventDefault();
			// if clicked on an lpSelect dropdown
			if ($target.closest('.lpSelectNew .dropdown').length) {

				// if an options panel is open
				if ($('.lpSelectNew .options:visible').length) {

					// if it is this one, close it
					if ($scope.find('.options:visible').length) {

						lp.cart.shippingSelect.closeDd($('.lpSelectNew .options:visible'));
						return false;
						// else, close it and open this one

					} else {

						lp.cart.shippingSelect.closeDd($('.lpSelectNew .options:visible'));

					}

				}
				// set current value to highlighted
				$scope
					.find('[data-value="' + $target.closest('.lpSelectNew').prev().val() + '"]')
					.parent()
					.addClass('highlighted');
				// open these options
				$scope.find('.options').slideDown('fast');
				// if clicked on an option, then select it and close

			} else if ($optionContainer.length) {

				// choose the option
				lp.cart.shippingSelect.choose($scope, $optionContainer);

			} else {

				lp.cart.shippingSelect.closeDd($('.lpSelect options:visible'));

			}

		} else {

			// close dd
			lp.cart.shippingSelect.closeDd($('.lpSelectNew .options:visible'));

		}

	},
	keydown: function (e) {

		var $scope = $(document.activeElement),
			$highlighted = $scope.find('.highlighted .option');
		if ($scope.is('.lpSelectNew')) {

			switch (e.which) {
				// on tab
				case 9: {

					if ($scope.find('.options:visible').length) {

						e.preventDefault();
						// choose
						if ($highlighted.length) {

							$scope.attr('data-selected', $highlighted.data('value'));
							$scope.find('.chosen').html($highlighted.html());
							$scope.prev().val($highlighted.data('value'));

						}
						// close dd
						lp.cart.shippingSelect.closeDd($scope.find('.options'));

					}
					break;

				}
				// on enter
				case 13: {

					e.preventDefault();
					// choose
					if ($highlighted.length) {

						$scope.attr('data-selected', $highlighted.data('value'));
						$scope.find('.chosen').html($highlighted.html());
						$scope.prev().val($highlighted.data('value'));

					}
					// close dd
					lp.cart.shippingSelect.closeDd($scope.find('.options'));
					break;

				}
				// on up
				case 38: {

					e.preventDefault();
					// choose
					if ($highlighted.length) {

						if (!$highlighted.is($scope.find('.option').first())) {

							if ($scope.find('.option').index($highlighted) > 0) {

								$highlighted.parent().removeClass('highlighted');
								$scope
									.find('.option')
									.eq($scope.find('.option').index($highlighted) - 1)
									.parent()
									.addClass('highlighted');

							}
							$highlighted = $scope.find('.highlighted .option');
							$scope.attr('data-selected', $highlighted.data('value'));
							$scope.find('.chosen').html($highlighted.html());
							$scope.prev().val($highlighted.data('value'));

						}

					}
					break;

				}
				// on down
				case 40: {

					e.preventDefault();
					// choose
					if ($highlighted.length) {

						if (!$highlighted.is($scope.find('.option').last())) {

							if ($scope.find('.option').index($highlighted) < $scope.find('.option').length) {

								$highlighted.parent().removeClass('highlighted');
								$scope
									.find('.option')
									.eq($scope.find('.option').index($highlighted) + 1)
									.parent()
									.addClass('highlighted');

							}
							$highlighted = $scope.find('.highlighted .option');

						}

					} else {

						$scope.find('.option').first().parent().addClass('highlighted');
						$highlighted = $scope.find('.highlighted .option');

					}
					$scope.attr('data-selected', $highlighted.data('value'));
					$scope.find('.chosen').html($highlighted.html());
					$scope.prev().val($highlighted.data('value'));
					break;

				}
			}

		}

	},
	hover: function () {

		$('.optionContainer').removeClass('highlighted');
		$(this).addClass('highlighted');

	},
	choose: function ($scope, $optionContainer) {

		// get prev selected option
		var prevValue = $scope.find('.optionContainer .selected').data('value');
		// remove slected class and add to new option
		$scope.find('.optionContainer').removeClass('selected');
		$optionContainer.addClass('selected');
		// store selected data
		$scope.attr('data-selected', $optionContainer.find('.option').data('value'));
		// place chosen option
		$scope.find('.chosen').html($optionContainer.find('.option').html());
		// set value for original select
		$scope.prev().val($optionContainer.find('.option').data('value'));
		// close dd
		lp.cart.shippingSelect.closeDd($scope.find('.options'));
		// if values are the same, don't postback
		if ($scope.attr('data-selected') !== prevValue) {

			$scope.prev().trigger('change');

		}

	},
	// close dd and fire event about it
	closeDd: function ($options) {

		var $el = $options.parents('.lpSelectNew');
		$el.trigger('beforeClose.shippingSelect');
		$options.slideUp('fast').promise().done(function () {

			$el.trigger('afterClose.shippingSelect');

		});

	}
};
